import { Injectable } from '@angular/core';
import {
  ACCOUNT_RECOVERY_PAGES,
  GENERIC,
  LOGIN_MODAL,
  VIEW_PAGE
} from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { VIEW_NAME } from '../../data-access/login-modal/constants/login-constant';
import { AnalyticsData } from '../../data-access/login-modal/models/adobeAnalytics.interface';
import { LoginModalSuperHelperSupportComponent } from './login-modal-super-helper-support-component';
@Injectable({
  providedIn: 'root'
})
export class LoginModalSuperHelperComponent extends LoginModalSuperHelperSupportComponent {
  forgotLoginPage(viewPage: string): void {
    const action = VIEW_PAGE.CONTINUE;
    this.adobeDatalayerService.updateAnalyticsLoginModal(
      action,
      viewPage,
      true
    );
  }

  trackAnalytics(
    analytics: AnalyticsData,
    pageSection: string,
    centerPage: boolean
  ): void {
    const viewPage = this.checkLoginPage(centerPage);
    if (analytics.eventDetails == GENERIC.PAGELOAD && analytics.startTime) {
      this.setSuccessTracker(analytics.action);
      const startTime = analytics.startTime;
      const endTime = performance.now();
      const durationMs = endTime - startTime;
      const durationSec = (durationMs / 1000).toFixed(2);
      let pageName = analytics.action.toLowerCase();
      const code = this.setPrefContent();
      if (this.facade.standalonePage) {
        pageName = analytics.action.replace(/\s/g, '');
        this.adobeDatalayerService.populatePageAssets(
          analytics.action,
          code.v39,
          code.v40,
          durationSec,
          viewPage
        );
      } else {
        pageName = `${viewPage}:${pageName}`;
        this.adobeDatalayerService.populateModalAssets(
          pageName,
          code.v39,
          code.v40
        );
      }
    } else {
      this.checkOtherEvents(analytics, pageSection, viewPage);
    }
  }

  checkOtherEvents(
    analytics: AnalyticsData,
    pageSection: string,
    viewPage: string
  ): void {
    if (analytics.eventDetails == GENERIC.ERROR) {
      this.facade.errorAdobeTracker$.next(false);
      this.adobeDatalayerService.setLoginAccountRecoveryGlobalError(
        viewPage,
        analytics.errorCode,
        analytics.errorMessage
      );
    } else {
      this.checkClickOrSuccess(analytics, pageSection, viewPage);
    }
  }

  checkClickOrSuccess(
    analytics: AnalyticsData,
    pageSection: string,
    viewPage: string
  ): void {
    if (analytics.eventDetails == GENERIC.CUSTOM) {
      this.successAdobeTracker$.next(false);
      this.adobeDatalayerService.setLoginAccountRecoverySuccess(
        viewPage + GENERIC.SUCCESS
      );
    } else {
      this.trackClickAnalytics(analytics, pageSection, viewPage);
    }
  }

  trackClickAnalytics(
    analytics: AnalyticsData,
    pageSection: string,
    viewPage: string
  ): void {
    if (pageSection === VIEW_NAME.LOGIN_CREDENTIALS_SCREEN) {
      this.loginScreen(analytics.action, viewPage);
    }
    if (pageSection === VIEW_NAME.FORGOT_LOGIN_SCREEN) {
      const action = `${viewPage}:${ACCOUNT_RECOVERY_PAGES.FORGOT_LOGIN}`;
      this.forgotLoginPage(action);
    }
    this.checkUnlockOrHelpPage(analytics.action, pageSection, viewPage);
  }

  checkUnlockOrHelpPage(
    viewName: string,
    pageSection: string,
    viewPage: string
  ): void {
    if (pageSection === VIEW_NAME.UNLOCK_ACCOUNT_SCREEN) {
      const action = `${viewPage}:${ACCOUNT_RECOVERY_PAGES.UNLOCK_ACCOUNT}`;
      this.unlockYourAccountOrLoginHelpPage(viewName, action, pageSection);
    }
    if (pageSection === VIEW_NAME.LOGIN_HELP_SCREEN) {
      const action = `${viewPage}:${ACCOUNT_RECOVERY_PAGES.LOGIN_HELP}`;
      this.unlockYourAccountOrLoginHelpPage(viewName, action, pageSection);
    }
    if (pageSection === VIEW_NAME.CHECK_YOUR_EMAIL_SCREEN) {
      const action = `${viewPage}:${ACCOUNT_RECOVERY_PAGES.CHECK_YOUR_EMAIL}`;
      this.forgotLoginPage(action);
    }
    this.checkResetPasswordPage(viewName, pageSection, viewPage);
  }

  unlockYourAccountOrLoginHelpPage(
    viewName: string,
    viewPage: string,
    pageSection: string
  ): void {
    let name = '';
    name = this.resetPasswordButton(viewName, pageSection);
    const viewNameMap = {
      [VIEW_PAGE.LOGIN_HELP.toLowerCase()]: LOGIN_MODAL.LOGIN_HELP,
      [VIEW_PAGE.FORGOT_LOGIN.toLowerCase()]: LOGIN_MODAL.SEND_LOGIN
    };
    name = viewNameMap[viewName.toLowerCase()];
    this.adobeDatalayerService.updateAnalyticsLoginModal(name, viewPage, true);
  }
}
